<template>
  <div class="frame">
    <!-- <share :src="fxSrc" :contentTitle="data.title" @click="shareClick" /> -->
    <iframe :src="href" class="frame" />
  </div>
</template>
<script>
import qs from "qs";
// import Share from "../components/Share.vue";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  props: {
    NewsId: String,
  },
  data() {
    return {
      content: "",
      contentTitle: "",
      starttime: "",
      from: "",
      data: Object,
      href: "",
      fxSrc: "",
    };
  },
  components: {
    // Share,
  },
  mounted() {
    // console.log("mounted", this);
    this.getGonggaoListDetail();
    this.fxSrc = window.location.href;
    this.$apis.CmsInterface.addIntegral(this.$axios, {
            type: 1,
            creditDesc: '阅读-首页公告'
          })
  },
  methods: {
    shareClick() {
      console.log("mounted", this.src);
    },
    getGonggaoListDetail() {
      this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "HOMENOTICE",
        id: this.NewsId,
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            console.log(res);
            this.data = res.data.data;

            if (res.data.data.url && res.data.data.url != "") {
              this.href = res.data.data.url;
              return;
            } else {
              this.content = res.data.data.content;
              res.data.data.starttime = res.data.data.starttime.substring(
                0,
                10
              );
              this.data = res.data.data;
              this.href = "/GonggaoListDetail?NewsId=" + this.NewsId;
            }
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.frame {
  width: 100vw;
  height: 100vh;
  position: relative;
  border: none;
}
</style>